"use client";

import { c as _c } from "react/compiler-runtime";
import type { Entry, UnresolvedLink } from "contentful";
import type { TypeButtonSkeleton, TypeExternalButtonSkeleton, TypeImageSkeleton } from "@/types/contentful/generated";
import HeroLayout from "./HeroLayout";
import TrustpilotServiceReviewsClient from "./TrustpilotServiceReviewsClient";
type ButtonLike = Entry<TypeButtonSkeleton | TypeExternalButtonSkeleton, undefined, string> | UnresolvedLink<"Entry">;
interface Props {
  heading: string;
  subheading: string;
  cta: ButtonLike[];
  isShowReviews: boolean;
  image: Entry<TypeImageSkeleton, undefined, string> | UnresolvedLink<"Entry">;
  layout: "Image left" | "Image right";
}
export default function HeroClient(t0) {
  const $ = _c(10);
  const {
    heading,
    subheading,
    cta,
    isShowReviews,
    image,
    layout
  } = t0;
  let t1;
  if ($[0] !== isShowReviews) {
    t1 = isShowReviews ? <TrustpilotServiceReviewsClient /> : undefined;
    $[0] = isShowReviews;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== cta || $[3] !== heading || $[4] !== image || $[5] !== isShowReviews || $[6] !== layout || $[7] !== subheading || $[8] !== t1) {
    t2 = <HeroLayout heading={heading} subheading={subheading} cta={cta} isShowReviews={isShowReviews} image={image} layout={layout} reviews={t1} />;
    $[2] = cta;
    $[3] = heading;
    $[4] = image;
    $[5] = isShowReviews;
    $[6] = layout;
    $[7] = subheading;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}